import ButtonLink from '@/common/components/ButtonLink'
import { FileUploader } from '@/common/components/FileUploader'
import GoBackButton from '@/common/components/GoBackButton'
import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import useCompany from '@/common/hooks/queries/useCompany'
import { getFilenameFromUrl } from '@/common/utils/getFilenameFromUrl'
import { BillDetails } from '@/features/privateCompanies/components/showContract/BillDetails'
import { ContractGeneralInformation } from '@/features/privateCompanies/components/showContract/ContractGeneralInformation'
import { CreditLimits } from '@/features/privateCompanies/components/showContract/CreditLimits'
import { FeeDetails } from '@/features/privateCompanies/components/showContract/FeeDetails'
import { FiscalDetails } from '@/features/privateCompanies/components/showContract/FiscalDetails'
import { useCompanyContract } from '@/features/privateCompanies/hooks/useCompanyContract'
import { useCompanyContractClosingDate } from '@/features/privateCompanies/hooks/useCompanyContractClosingDate'
import { ChevronsRightIcon, UserRoundIcon } from 'lucide-react'
import { useParams } from 'react-router-dom'

const Show = () => {
  const { companyId, id: contractId } = useParams()

  const { data: company } = useCompany({ id: companyId || '' })

  const { data: contract, dataUpdatedAt: contractUpdatedAt } = useCompanyContract({ id: contractId || '' })

  const { data: contractClosingDate } = useCompanyContractClosingDate({
    id: contractId || '',
  })

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-1 items-center">
          <GoBackButton fallback={`/companies/${companyId}`} />
          <h2 className="text-white-400">{company?.general_information?.fantasy_name}</h2>
          <ChevronsRightIcon strokeWidth={1} size={32} className="text-white-400" />
          <h2>Contrato</h2>
        </div>
      </div>
      <div className="flex flex-col bg-white-100 rounded-md center p-4 gap-4 overflow-y-auto max-h-[calc(100vh-128px)] w-full">
        <div className="flex w-full items-center justify-between gap-2">
          <div>
            <p className="font-bold text-lg">Contrato</p>
          </div>
          <div className="flex flex-col gap-0.5 items-end">
            <div className="flex gap-2 items-center">
              <ButtonLink
                linkTo={`/users/${company?.commercial_manager?.id}`}
                operationKlassToCheckPermission='Admin::Users::Show'
              >
                <ImageWithPlaceholder
                  url={company?.commercial_manager?.profile_picture?.url}
                  alt={company?.commercial_manager?.full_name}
                  className="size-6"
                  iconClassName="size-4"
                  placeholderIcon={UserRoundIcon}
                />

                <p className="font-bold text-xs">{company?.commercial_manager?.full_name}</p>
              </ButtonLink>
            </div>
            <p className="font-light text-sm text-blue-800 italic">Condição comercial - {contract?.protocol_number}</p>
          </div>
        </div>
        <FileUploader
          label=""
          title="Contrato assinado"
          name="document"
          accept="application/pdf"
          fileName={contract?.file?.url ? getFilenameFromUrl(contract.file.url) : undefined}
          currentFileUrl={contract?.file?.url ? contract.file.url : undefined}
          disabled
        />
        <BillDetails contract={contract} contractClosingDate={contractClosingDate} companyKind={company?.kind}  />
        <FiscalDetails contract={contract} />
        <CreditLimits contract={contract} companyKind={company?.kind} />
        <FeeDetails contract={contract} companyKind={company?.kind} contractUpdatedAt={contractUpdatedAt} />
        <ContractGeneralInformation contract={contract} />
      </div>
    </>
  )
}

export default Show
